export default __webpack_public_path__ + "static/media/LogoBlue.d26e8699.png";